import React from 'react';
import Lottie from 'lottie-react';
import loaderAnimation from '../../Assets/loader.json';

function LoadingSpinner() {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(255, 255, 255, 0.8)', // Optional: semi-transparent background
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999, // Ensure it's on top
    }}>
      <div style={{
        width: 150, // Reduced size for better proportion
        height: 150,
      }}>
        <Lottie 
          animationData={loaderAnimation}
          loop={true}
          autoplay={true}
        />
      </div>
    </div>
  );
}

export default LoadingSpinner;